import { useParams } from 'react-router-dom';
import { Layout } from 'antd';

import { TableWithForm } from 'components';

import { useGetHeaders, useUserRole } from 'hooks';

import { columns, fields, handleContributedOfferTableChange } from './contributedOffersHelpers';

export const ContributedOffers = () => {
  const { offerId } = useParams();

  const headers = useGetHeaders();

  const { isAdmin } = useUserRole();

  return (
    <Layout className='h-[500px]'>
      <TableWithForm
        horizontalScroll
        id='offer-contributed-table'
        size='small'
        columns={columns}
        defaultTableParams={{ current: 1, pageSize: 20 }}
        onTableChange={handleContributedOfferTableChange(headers, offerId)}
        // form
        fields={fields(isAdmin)}
        labelCol={{ span: 0 }}
        wrapperCol={{ span: 24 }}
      />
    </Layout>
  );
};
